import { DEFAULT_SUBDOMAIN, DEFAULT_TENANT } from '../../../core/services/tenant/constants'
import { platform } from '../../../core/services/device/platform'
import { Tenant } from '../../../core/services/tenant'

export async function fetchLogo (): Promise<string> {
  if (platform !== 'web') return await Promise.resolve('/assets/images/logo.svg')
    const tenant = new Tenant()
  return await fetch(`${tenant.getAPIBaseURL()}/api/desktops/logo?get_url=true&s=${tenant.subdomain ?? ''}`, {
    credentials: (tenant.subdomain ?? '').includes(DEFAULT_SUBDOMAIN) ? 'include' : 'omit',
    headers: {
      'Content-Type': 'Application/json'
    }
  })
    .then(async res => await res.json())
    .then(res => res.data.logo_url)
    .catch(() => DEFAULT_TENANT === 'auravant.com' ? '/assets/images/logo.svg' : null)
}
